export const googleAudienceOptions = {
  externalScope: [
    { label: 'Audience Rules for Web Page Visitors', value: 'audienceRules' },
    { label: 'Conversion Actions', value: 'conversionActions' },
  ],
  lookalikeType: [
    { label: 'Narrow', value: 'NARROW' },
    { label: 'Balanced', value: 'BALANCED' },
    { label: 'Broad', value: 'BROAD' },
  ],
};

export const userListFlexibleRuleOperator = [
  {
    name: 'Contains',
    key: 'contains',
    event: 'CONTAINS',
    inverseSelection: false,
    scope: 'google',
    type: 'url__',
    operand: 'include',
    availableFilters: {
      match: {},
      retentionDays: {},
    },
  },
  {
    name: 'Equals',
    key: 'equals',
    event: 'EQUALS',
    inverseSelection: false,
    scope: 'google',
    type: 'url__',
    operand: 'include',
    availableFilters: {
      match: {},
      retentionDays: {},
    },
  },
  {
    name: 'Starts with',
    key: 'startsWith',
    event: 'STARTS_WITH',
    inverseSelection: false,
    scope: 'google',
    type: 'url__',
    operand: 'include',
    availableFilters: {
      match: {},
      retentionDays: {},
    },
  },
  {
    name: 'Ends with',
    key: 'endsWith',
    event: 'ENDS_WITH',
    inverseSelection: false,
    scope: 'google',
    type: 'url__',
    operand: 'include',
    availableFilters: {
      match: {},
      retentionDays: {},
    },
  },
];
